// Cihaz kaydı yenileme — bildirim izni ZATEN verilmişse, girişte, panel açılışında ve oturum yenilendiğinde
// Firebase (fcm_tokens) ve tarayıcı web push (push_subscriptions) kaydı oturumdaki kullanıcıyla sessizce
// tazelenir. İzin sormaz. İdempotent: sunucu aynı cihazı (FCM token / web push adresi) tek kayıtta tutar
// ve son oturumun kullanıcısına bağlar. Kişi bazlı bildirimler (mola, vardiya, duyurular) bu bağa dayanır;
// eskiden kayıt yalnız girişte / zil düğmesinde yapılıyordu, günlerce tazelenmiyordu.
import axios from "axios";
import { API } from "./api";
import { getSession, isSessionValid, isTabletSession } from "./auth";

// Panel yolu → cihaz kaydı türü (eski panel bazlı gönderim user_type'ı bununla seçer)
const PATH_TYPES = {
  "/management": "manager",
  "/plan": "plan",
  "/operator": "operator",
  "/warehouse": "warehouse",
  "/bobin": "warehouse",
  "/marka-stok": "warehouse",
  "/boyaci": "boyaci",
  "/driver": "sofor",
};

export function panelUserType(pathname, session) {
  if (PATH_TYPES[pathname]) return PATH_TYPES[pathname];
  if (pathname === "/paint") {
    const roles = (session?.roles && session.roles.length ? session.roles : [session?.role]).filter(Boolean);
    if (roles.some((r) => ["depo", "plan", "yonetim"].includes(r))) return "warehouse";
    if (roles.includes("boyaci")) return "boyaci";
  }
  return null;   // panel dışı sayfa (ana sayfa, vardiya planı, kamera …): cihaz yine kullanıcıya bağlanır, FCM türü değiştirilmez
}

const THROTTLE_MS = 5 * 60 * 1000;
const _last = new Map();

// shouldRun: aynı kullanıcı + tür için kısa sürede tekrar etme (sayfa geçişleri); force → her zaman
export function shouldRun(key, now = Date.now(), force = false) {
  if (!force && _last.has(key) && now - _last.get(key) < THROTTLE_MS) return false;
  _last.set(key, now);
  return true;
}

export function _resetThrottle() { _last.clear(); }

export async function refreshDeviceRegistration(pathname, { force = false, deps = {} } = {}) {
  if (!isSessionValid() || isTabletSession()) return { skipped: "no_session" };
  const s = getSession();
  const userId = s?.user_id || s?.username;
  const userType = panelUserType(pathname, s);
  if (!shouldRun(`${userId}|${userType || "-"}`, Date.now(), force)) return { skipped: "throttled" };
  const out = { fcm: false, webpush: false, userType };
  const {
    isNative = () => require("../pushNotifications").isNativePlatform(),
    nativeRefresh = (t) => require("../pushNotifications").refreshNativeRegistration(t),
    getToken = () => require("../firebase").getTokenIfPermitted(),
    ensureWebPush = () => require("./messenger").ensurePushSubscription(),
  } = deps;
  if (isNative()) {
    out.fcm = await nativeRefresh(userType);
    return out;
  }
  if (typeof window === "undefined" || !("Notification" in window) || Notification.permission !== "granted") {
    return { ...out, skipped: "no_permission" };
  }
  try {
    const token = await getToken();
    if (token) {
      await axios.post(`${API}/notifications/register-token`, { token, platform: "web", ...(userType ? { user_type: userType } : {}) });
      out.fcm = true;
    }
  } catch { /* sessiz */ }
  try {
    const r = await ensureWebPush();   // izin verilmişse pencere açmaz; adres başına tek kayıt
    out.webpush = !!r?.granted;
  } catch { /* sessiz */ }
  return out;
}
